import { createStructuredSelector } from 'reselect'

import {
  EQUIPMENT_STOCK_LIST,
  EQUIPMENT_STOCK_LIST_SUCCESS, 
  EQUIPMENT_STOCK_LIST_ERROR,
  EQUIPMENT_STOCK_PAGE_SET,
  EQUIPMENT_STOCK_SEARCH_SET,
  EQUIPMENT_STOCK_SEARCH_CHANGE,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_SUCCESS,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_ERROR, 
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_SUCCESS,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_ERROR, 
  EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT,
  EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_SUCCESS,
  EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_ERROR, 
  EQUIPMENT_STOCK_ADD_SET,
  EQUIPMENT_STOCK_ADD_MODAL_SET,
  EQUIPMENT_STOCK_ADD,
  EQUIPMENT_STOCK_ADD_SUCCESS,
  EQUIPMENT_STOCK_ADD_ERROR,
  EQUIPMENT_STOCK_ADD_CHANGE,
  EQUIPMENT_STOCK_DETAIL,
  EQUIPMENT_STOCK_DETAIL_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ERROR,
  EQUIPMENT_STOCK_GET,
  EQUIPMENT_STOCK_GET_SUCCESS,
  EQUIPMENT_STOCK_GET_ERROR,
  EQUIPMENT_STOCK_VIEW_MODAL_SET,
  EQUIPMENT_STOCK_EDIT_CHANGE,
  EQUIPMENT_STOCK_EDIT_MODAL_SET,
  EQUIPMENT_STOCK_UPDATE,
  EQUIPMENT_STOCK_UPDATE_SUCCESS,
  EQUIPMENT_STOCK_UPDATE_ERROR,
  EQUIPMENT_STOCK_VIEW_TAB_SET,
  EQUIPMENT_STOCK_UPLOAD_SET,
  EQUIPMENT_STOCK_UPLOAD_SET_SUCCESS,
  EQUIPMENT_STOCK_UPLOAD_SET_ERROR,
  EQUIPMENT_STOCK_UPLOAD_RESET
} from '../../actions';

export const NAME = 'equipment_stock';

export const EquipmentStockList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EQUIPMENT_STOCK_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EquipmentStockListSuccess = (data) => ({
  type: EQUIPMENT_STOCK_LIST_SUCCESS,
  payload: data
});

export const EquipmentStockListError = (error) => ({
  type: EQUIPMENT_STOCK_LIST_ERROR,
  payload: error
});

export const EquipmentStockPageSet = (data) => ({
  type: EQUIPMENT_STOCK_PAGE_SET,
  payload: data
});

export const EquipmentStockSearchSet = (data) => ({
  type: EQUIPMENT_STOCK_SEARCH_SET,
  payload: data
});

export const EquipmentStockSearchChangeSet = (data) => ({
  type: EQUIPMENT_STOCK_SEARCH_CHANGE,
  payload: data
});

export const EquipmentStockSearchAssessment = (data) => ({
  type: EQUIPMENT_STOCK_SEARCH_ASSESSMENT,
  payload: data
});

export const EquipmentStockSearchAssessmentSuccess = (message) => ({
  type: EQUIPMENT_STOCK_SEARCH_ASSESSMENT_SUCCESS,
  payload: message
});

export const EquipmentStockSearchAssessmentError = (error) => ({
  type: EQUIPMENT_STOCK_SEARCH_ASSESSMENT_ERROR,
  payload: error
}); 

export const EquipmentStockSearchAssessmentProject = (data) => ({
  type: EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT,
  payload: data
});

export const EquipmentStockSearchAssessmentProjectSuccess = (message) => ({
  type: EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_SUCCESS,
  payload: message
});

export const EquipmentStockSearchAssessmentProjectError = (error) => ({
  type: EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_ERROR,
  payload: error
}); 

export const EquipmentStockSearchSupervisionReport = (data) => ({
  type: EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT,
  payload: data
});

export const EquipmentStockSearchSupervisionReportSuccess = (message) => ({
  type: EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_SUCCESS,
  payload: message
});

export const EquipmentStockSearchSupervisionReportError = (error) => ({
  type: EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_ERROR,
  payload: error
}); 

export const EquipmentStockAddChangeSet = (data) => ({
  type: EQUIPMENT_STOCK_ADD_CHANGE,
  payload: data
});

export const EquipmentStockAddSet = (data) => ({
  type: EQUIPMENT_STOCK_ADD_SET,
  payload: data
});

export const EquipmentStockAddModalSet = (data) => ({
  type: EQUIPMENT_STOCK_ADD_MODAL_SET,
  payload: data
});

export const EquipmentStockAdd = (data) => ({
  type: EQUIPMENT_STOCK_ADD,
  payload: data
});

export const EquipmentStockAddSuccess = (message) => ({
  type: EQUIPMENT_STOCK_ADD_SUCCESS,
  payload: message
});

export const EquipmentStockAddError = (error) => ({
  type: EQUIPMENT_STOCK_ADD_ERROR,
  payload: error
});


export const EquipmentStockGet = (data) => ({
  type: EQUIPMENT_STOCK_GET,
  payload: data
});

export const EquipmentStockGetSuccess = (data) => ({
  type: EQUIPMENT_STOCK_GET_SUCCESS,
  payload: data
});

export const EquipmentStockGetError = (error) => ({
  type: EQUIPMENT_STOCK_GET_ERROR,
  payload: error
});

export const EquipmentStockDetail = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL,
  payload: data
});

export const EquipmentStockDetailSuccess = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_SUCCESS,
  payload: data
});

export const EquipmentStockDetailError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ERROR,
  payload: error
});
export const EquipmentStockViewModalSet = (data) => ({
  type: EQUIPMENT_STOCK_VIEW_MODAL_SET,
  payload: data
});

export const EquipmentStockEditModalSet = (data) => ({
  type: EQUIPMENT_STOCK_EDIT_MODAL_SET,
  payload: data
});

export const EquipmentStockEditChangeSet = (data) => ({
  type: EQUIPMENT_STOCK_EDIT_CHANGE,
  payload: data
});

export const EquipmentStockUpdate = (data) => ({
  type: EQUIPMENT_STOCK_UPDATE,
  payload: data
});

export const EquipmentStockUpdateSuccess = (message) => ({
  type: EQUIPMENT_STOCK_UPDATE_SUCCESS,
  payload: message.message
});

export const EquipmentStockUpdateError = (error) => ({
  type: EQUIPMENT_STOCK_UPDATE_ERROR,
  payload: error
});

export const EquipmentStockViewTabSet = (data) => ({
  type: EQUIPMENT_STOCK_VIEW_TAB_SET,
  payload: data
});

export const EquipmentStockUploadSet = (file) => ({
  type: EQUIPMENT_STOCK_UPLOAD_SET,
  payload: { file },
});

export const EquipmentStockUploadSetSuccess = (items) => ({
  type: EQUIPMENT_STOCK_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const EquipmentStockUploadSetError = (error) => ({
  type: EQUIPMENT_STOCK_UPLOAD_SET_ERROR,
  payload: error,
});

export const EquipmentStockUploadReset= () => ({
  type: EQUIPMENT_STOCK_UPLOAD_RESET
});

const equipment_stock = (state) => state[NAME];

export const EquipmentStockSelector = createStructuredSelector({
  equipment_stock
})
 